import { Logo } from "@p0security/frontend-core/react";

export const PermissionSetLabel: React.FC<{ label: string }> = ({ label }) => (
  <>
    <Logo
      title="AWS Identity Center"
      logo="https://a.b.cdn.console.awsstatic.com/a/v1/HO7L7EF5K5RONI4EDMYKMTQFF2J3KTWWKAMKFXXPIQ43QLSNUF6A/icon/b5164fbdf0a4526876438e688f5e4130-8f4c3d179652d29309b38012bd392a52.svg"
    />
    &nbsp;{label}
  </>
);
